'use strict';

export default function isCancel(value) {
  return !!(value && value.__CANCEL__);
}



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/cancel/isCancel.js
// module id = pBtG
// module chunks = 4